import {
  afterRenderEffect,
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { MinesService } from '../mines.service';
import { MinesTileComponent } from '../mines-tile/mines-tile.component';
import { ModalService } from '@features/modals/services/modal.service';

@Component({
  selector: 'app-mines-board',
  templateUrl: './mines-board.component.html',
  styleUrls: ['./mines-board.component.scss'],
  standalone: true,
  imports: [MinesTileComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MinesBoardComponent {
  constructor(
    public minesService: MinesService,
    private modalService: ModalService
  ) {
    afterRenderEffect(() => {
      const game = this.minesService.currentGame();

      if (game?.status === 'finished') {
        const minesResultsModal = this.modalService.openModal(
          'MinesResultsModalComponent',
          {
            results: {
              multiplier: minesService.multiplier(),
              balance: game.balancetype,
              value: minesService.multiplier() * (game?.value || 0),
              won: game.won,
            },
          }
        );
      }
    });

    afterRenderEffect(() => {
      const game = this.minesService.currentGame();

      if (this.minesService.repeat() && game?.status !== 'active') {
        this.minesService.placeBet();
      }
    });
  }
}
